import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Pagination from "../../components/Pagination";
import BackendLayout from "../../layouts/BackendLayout";
import { useDocumentTitle } from "../../hooks";
import { getDepartmentMasterUpdateHistorySearchPageSettings } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { DEPARTMENT_MASTER_HISTORY_SEARCH } from "../../constants/routes";
import { PageTitle } from "../../components/admin";
import { useGetLogs } from "../../hooks";
import PageAlert from "../../components/alerts/PageAlert";
import {
  clearPageLoading,
  resetAlert,
  setPageLoading,
} from "../../store/actions";
import { API_DEPARTMENT_GET_LOGS } from "../../constants/api";
import { API_DEPARTMENT_DOWNLOAD_LOGS } from "../../constants/api";
import { LogItem, LogPanelFilter } from "../../components/logs";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import {ButtonDPad, RedirectAlert} from "../../components";
import {DEPARTMENT_MASTER_HISTORY_SEARCH_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

export default function DepartmentHistorySearchPage() {
  useRedirectPage(DEPARTMENT_MASTER_HISTORY_SEARCH_PAGE);
  const breadcrumb = getRouteBreadcrumb(DEPARTMENT_MASTER_HISTORY_SEARCH);
  const dispatch = useDispatch();
  useDocumentTitle("部門マスタ更新履歴検索 - 点検王");

  const setDepartmentHistorySearchPageSettings = async (e) => {
    dispatch(setPageLoading());
    const pageSettings =
      await getDepartmentMasterUpdateHistorySearchPageSettings();
    dispatch(setPageSettings(pageSettings));
    dispatch(clearPageLoading());
  };
  useEffect(() => {
    setDepartmentHistorySearchPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const BUTTON_SEARCH_DEPARTMENT_HISTORY = "button__search-department-history";
  const [reload, setReload] = useState(0);
  const {
    errors,
    logs,
    page,
    perPage,
    totalCount,
    dataSearch,
    setErrors,
    setPage,
    setPerPage,
    SetDataSearch,
  } = useGetLogs(
    reload,
    API_DEPARTMENT_GET_LOGS,
    "department_history_search",
    BUTTON_SEARCH_DEPARTMENT_HISTORY
  );

  const handleSubmitSearch = () => {
    dispatch(resetAlert());
    setErrors({});
    setReload(reload + 1);
  };

  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="部門マスタ更新履歴検索" />
      <div className="lg:hidden">
        <ButtonDPad />
      </div>
      <div className="history-search__content  xl:w-full w-fit xl:pr-0 pr-6">
        <p className="font-light xl:mb-3 mb-2">
          50MB までのxlsxファイルをダウンロードすることができます。
        </p>
        <RedirectAlert />
        <PageAlert />
        <LogPanelFilter
          formData={dataSearch}
          setFormData={SetDataSearch}
          handleSubmitSearch={handleSubmitSearch}
          errors={errors}
          buttonId={BUTTON_SEARCH_DEPARTMENT_HISTORY}
        />
        <div className="machine-infor__list">
          <LoadingSpinner component="department_history_search" />
          {logs.length > 0 ? (
            logs.map((item, index) => (
              <LogItem
                index={index}
                item={item}
                apiUrl={API_DEPARTMENT_DOWNLOAD_LOGS}
              />
            ))
          ) : (
            <p>
              該当する検索結果が見つかりませんでした。別の検索条件をお試しください。
            </p>
          )}
        </div>
        <div className="md:mt-5 xl:mt-8">
          <Pagination
            setPage={setPage}
            currentPage={page}
            pageSize={perPage}
            totalCount={totalCount}
            showIndex={totalCount > 0}
            setPageSize={totalCount > 0 ? setPerPage : null}
          />
        </div>
      </div>
    </BackendLayout>
  );
}
